import React, { useRef, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { FiChevronDown } from 'react-icons/fi';
import { RootState } from '../../PanesPanel/types';
import { makeSelectContext } from '../../Configurator/selectors/general';
import { FurnitureEditorContext } from '../../../lib/constraintsChecker/FurnitureEditor';
import useOnClickOutside from 'use-onclickoutside';
import { setContextAction } from '../../Configurator/actions/general';

// import styled from 'styled-components';

interface StateProps {
  context: FurnitureEditorContext;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  context: makeSelectContext(),
});

const ContextSwitcher = () => {
  const dispatch = useDispatch();
  const { context } = useSelector(stateSelector);

  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useOnClickOutside(ref, () => {
    setOpen(false);
  });

  function select(value: FurnitureEditorContext) {
    // Dispatch
    dispatch(setContextAction(value));
    setOpen(false);
  }

  function handleOnClick() {
    setOpen(!open);
  }

  return (
    <div className="">
      <button
        onClick={handleOnClick}
        className="flex items-center text-sm mx-2"
      >
        Context: <span className="italic">{context}</span>{' '}
        <FiChevronDown className="h-3 w-3" />
      </button>
      {open && (
        <div className="bg-white border border-gray-400">
          <ul>
            <li>
              <button
                onClick={() => {
                  select(FurnitureEditorContext.webShop);
                }}
              >
                Webshop
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  select(FurnitureEditorContext.sales);
                }}
              >
                Sales
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  select(FurnitureEditorContext.projects);
                }}
              >
                Project
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ContextSwitcher;
